/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Dropbox_Ingest_Approval_DescriptionInputs */

const es_components_dropbox_ingest_approval_description = /** @type {(inputs: Components_Dropbox_Ingest_Approval_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El asistente quiere ingestar archivos de Dropbox`)
};

const en_components_dropbox_ingest_approval_description = /** @type {(inputs: Components_Dropbox_Ingest_Approval_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant wants to ingest files from Dropbox`)
};

/**
* | output |
* | --- |
* | "The assistant wants to ingest files from Dropbox" |
*
* @param {Components_Dropbox_Ingest_Approval_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_dropbox_ingest_approval_description = /** @type {((inputs?: Components_Dropbox_Ingest_Approval_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Dropbox_Ingest_Approval_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_dropbox_ingest_approval_description(inputs)
	return en_components_dropbox_ingest_approval_description(inputs)
});
export { components_dropbox_ingest_approval_description as "components.dropbox_ingest_approval.description" }